import { configureAuth } from "auth/authProvider";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { initSentry } from "sentry";
import App from "./App";
import reportWebVitals from "./utils/reportWebVitals";

!import.meta.env.DEV && initSentry();
configureAuth();

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

console.log("current frontend version:", import.meta.env.VITE_APP_VERSION);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
